// Sentry
export const SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN || "";
export const SENTRY_RELEASE = import.meta.env.REACT_APP_SENTRY_RELEASE || "";

// Posthog
export const PUBLIC_POSTHOG_KEY = import.meta.env.REACT_APP_PUBLIC_POSTHOG_KEY || "";
export const PUBLIC_POSTHOG_HOST = import.meta.env.REACT_APP_PUBLIC_POSTHOG_HOST || "";

// Testing
export const DEFAULT_WAIT_TIME = 10 * 1000; // 10 seconds

// Delays
export const DEFAULT_TOOLTIP_DELAY = 1000;

// Date formats
export const DATE_FORMATS = {
  FULL_DATE: "DD-MMM-YYYY",
};
